import TextEditor from "../TextEditor";
import { Button } from "@aws-amplify/ui-react";

export const TextEditorBlock = ({ value, onChange }) => {
  const handleChange = (index, textValue) => {
    const updatedItems = [...value];

    updatedItems[index] = textValue;

    onChange(updatedItems);
  };

  const onRemoveClick = (indexToRemove) => {
    const updatedItems = value.filter((_, i) => i !== indexToRemove);
    onChange(updatedItems);
  };

  const handleAddItem = () => {
    const newItem = "";

    const updatedItems = [...value, newItem];
    onChange(updatedItems);
  };
  return (
    <>
      {value.map((textContent, index) => {
        return (
          <TextEditor
            key={index}
            textFieldCount={value.length}
            editorIndex={index}
            initialValue={textContent}
            onEditorChange={handleChange}
            removeHandler={onRemoveClick}
          />
        );
      })}
      <Button onClick={handleAddItem}>Add TextField</Button>
    </>
  );
};
